import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MbIconModule } from '../mb-icon/mb-icon.module';
import { LeftMenuComponent } from './left-menu.component';

@NgModule({
    declarations: [LeftMenuComponent],
    imports: [
        CommonModule,
        MatDividerModule,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        MbIconModule,
    ],
    exports: [LeftMenuComponent],
})
export class LeftMenuModule {}
